import { NavLink } from 'react-router-dom'

import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  align-items: flex-start;
`

export const WrapperLink = styled(NavLink)`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const Container = styled.div`
  line-height: 1.1125;
  font-size: 0.75rem;

  .title {
    font-weight: 600;
  }
`
